import axiosClient from "../axios-client";
import axiosSvClient from "../axios-sv-client";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";
export const editorToolbarSettings = [
  "Bold",
  "Italic",
  "StrikeThrough",
  "|",
  "Formats",
  "Blockquote",
  "OrderedList",
  "UnorderedList",
  "|",
  "CreateLink",
  "Image",
  "CreateTable",
  "|",
  "Undo",
  "Redo",
];

export const getAllBlogList = async (dispatch) => {
  changeLoaderStatus(dispatch, true);
  return axiosSvClient
    .get(`/blog-posts?no_filters=true&offset=0&limit=999`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toastMessage("Blog details not found", "error");
      return error;
    })
    .finally(() => {
      setTimeout(() => {
        changeLoaderStatus(dispatch, false);
      }, 500);
    });
};


export const getAuthorList = async () => {
  return axiosSvClient
    .get("/blog-authors")
    .then((res) => {
      return res?.data?.authors;
    })
    .catch((error) => {
      toastMessage("Author list not found", "error");
      return error;
    });
};

export const getCategoryList = async () => {
  return axiosSvClient
    .get("/blog-categories")
    .then((res) => {
      return res?.data?.categories;
    })
    .catch((error) => {
      toastMessage("Category list not found", "error");
      return error;
    });
};

export const getSelectedBlogDetails = async (dispatch, id) => {
  changeLoaderStatus(dispatch, true);
  return axiosSvClient
    .get(`/blog-posts?post_id=${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toastMessage("Blog details not found", "error");
      return error;
    })
    .finally(() => {
      setTimeout(() => {
        changeLoaderStatus(dispatch, false);
      }, 500);
    });
};

export const createBlog = async (formData, dispatch) => {
  changeLoaderStatus(dispatch, true);
  return axiosClient
    .post(`/blog/create`, formData)
    .then((res) => {
      toastMessage("Blog created successfully.", "success");
      return res?.data;
    })
    .catch((error) => {
      toastMessage("Blog not created.", "error");
      throw error;
    })
    .finally(() => {
      setTimeout(() => {
        changeLoaderStatus(dispatch, false);
      }, 500);
    });
};

export const updateBlog = async (id, formData, dispatch) => {
  changeLoaderStatus(dispatch, true);
  return axiosClient
    .patch(`/blog/update/${id}`, formData)
    .then((res) => {
      toastMessage("Blog updated successfully.", "success");
      return res?.data;
    })
    .catch((error) => {
      toastMessage("Blog not updated.", "error");
      throw error;
    })
    .finally(() => {
      setTimeout(() => {
        changeLoaderStatus(dispatch, false);
      }, 500);
    });
};
